import React from 'react';

const LayoutProviderContext = React.createContext({});

export { LayoutProviderContext };
